import { render } from "./App.vue?vue&type=template&id=5918f504&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5918f504&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/sppd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5918f504"]])

export default __exports__